import loadable from '@loadable/component';

// Compare Alternatives
const NoResults = loadable(() => import(/* webpackChunkName: "no-results" */ './no-results-component'), {
  resolveComponent: (components) => components.NoResults,
});

export { NoResults };
